export { ArrowCaretRightSm5 } from "./ArrowCaretRightSm5";
